import { StatusIndicatorProps } from "@amzn/awsui-components-react/polaris/status-indicator/internal";
import {
  Box,
  BoxProps,
  Button,
  Popover,
  SpaceBetween,
  StatusIndicator,
} from "@amzn/awsui-components-react";
import React, { useState } from "react";
import useFetchDlqRedriveInfo, {
  DlqRedriveStatus,
} from "../../hooks/useFetchDlqRedriveInfo";
import { DLQItem } from "../../lusca-search-api/generated-src";

interface DlqIndicatorEntry {
  indicator: StatusIndicatorProps.Type;
  color: BoxProps.Color;
  message: string;
}

export const dlqIndicator: Record<DlqRedriveStatus, DlqIndicatorEntry> = {
  unknown: {
    indicator: "in-progress",
    color: "text-label",
    message: "Unknown",
  },
  loading: {
    indicator: "loading",
    color: "text-label",
    message: "Checking requeue...",
  },
  success: {
    indicator: "success",
    color: "text-status-success",
    message: "Requeued",
  },
  error: {
    indicator: "error",
    color: "text-status-error",
    message: "Error requeuing",
  },
};

interface DlqRedriveStatusIndicatorProps {
  stage: string;
  dlqItem: DLQItem;
}

const DlqRedriveStatusIndicator: React.FC<DlqRedriveStatusIndicatorProps> = (
  props
) => {
  const { stage, dlqItem } = props;

  const [shouldRedrive, requestRedrive] = useState(false);
  const { redrivenMessages } = useFetchDlqRedriveInfo(
    stage,
    dlqItem.pk,
    shouldRedrive
  );
  const { status, error } =
    (shouldRedrive ? redrivenMessages?.get(dlqItem.pk) : null) ?? { status: "unknown", error: "Result not found" };

  const { indicator, color, message } = dlqIndicator[status];
  const statusIndicatorContent = (
    <StatusIndicator type={indicator}>{message}</StatusIndicator>
  );

  const renderContent = () => {
    if (status !== "unknown") {
      return (
        <Box color={color} display="inline-block">
          {error ? (
            <SpaceBetween alignItems="center" direction="horizontal" size="xxs">
              <Popover
                dismissButton={false}
                fixedWidth={false}
                position="bottom"
                size="large"
                triggerType="custom"
                content={error}
              >
                <Button
                  iconName="status-info"
                  variant="inline-icon"
                  ariaLabel="Show explaination"
                />
              </Popover>
              {statusIndicatorContent}
            </SpaceBetween>
          ) : (
            statusIndicatorContent
          )}
        </Box>
      );
    }

    return (
      <SpaceBetween alignItems="center" direction="horizontal" size="xxs">
        <Popover
          dismissButton={false}
          fixedWidth={false}
          position="bottom"
          size="large"
          triggerType="custom"
          content="DLQ items may be 60 minutes out of date."
        >
          <Button
            iconName="status-info"
            variant="inline-icon"
            ariaLabel="Show explaination"
          />
        </Popover>
        <Button
          onClick={() => requestRedrive(true)}
          ariaLabel="Requeue message"
        >
          Requeue message
        </Button>
      </SpaceBetween>
    );
  };

  return (
    <Box color={color} display="inline-block">
      {renderContent()}
    </Box>
  );
};

DlqRedriveStatusIndicator.defaultProps = {};

export default DlqRedriveStatusIndicator;
